import moment from 'moment';

import type { Moment } from 'moment';
import type { ITargetTrialDurationEvent, TargetProgress } from '../../../../../utils/types';

export function checkRateEventsInRange(
  targetProgress: TargetProgress[] = [],
  startTime: Moment,
  duration: number,
): number {
  const endTime = moment(startTime).add(duration, 'seconds');
  let outOfRangeCount = 0;

  targetProgress.forEach((target) => {
    target.target_evaluations.forEach((targetEvaluation) => {
      targetEvaluation.rate_events?.forEach((event) => {
        const eventTime = moment(event.date_of_event);
        if (eventTime.isSameOrBefore(startTime) || eventTime.isSameOrAfter(endTime)) {
          outOfRangeCount += 1;
        }
      });
    });
  });

  return outOfRangeCount;
}

export function checkDurationEventsInRange(
  targetProgress: TargetProgress[] = [],
  newDuration: number,
): boolean {
  return targetProgress.some((trial) =>
    trial.target_evaluations.some((targetEvaluation) => {
      const totalTrialDuration =
        targetEvaluation.duration_events?.reduce(
          (acc: number, duration: ITargetTrialDurationEvent) => acc + (duration?.duration ?? 0),
          0,
        ) ?? 0;
      return totalTrialDuration > newDuration;
    }),
  );
}

export function hasRateEvents(targetProgress: TargetProgress[] = []): boolean {
  return targetProgress.some((target) =>
    target.target_evaluations.some((targetEvaluation) =>
      Boolean(targetEvaluation.rate_events?.length),
    ),
  );
}
